export const searchToggle = function (el) {
    const searchEnabler = el.querySelector("[data-enable-search]");
    const searchDisabler = el.querySelector("[data-disable-search]");
    console.log(searchEnabler, searchDisabler);
    if (searchEnabler) {
        searchEnabler.addEventListener("click", function () {
            el.classList.add("search-enabled");
            document.querySelector(".search__input").focus();
            document.body.classList.add("search-enabled");
        });
    }
    if (searchDisabler) {
        searchDisabler.addEventListener("click", function () {
            el.classList.remove("search-enabled");
            document.body.classList.remove("search-enabled");
        });
    }
};
